import React from 'react';
import {DragDropContextProps} from '../models';
import {DragDropContextStore} from './DragDropContextStore';
import {DragDropReactContext} from './DragDropReactContext';

export class DragDropContext extends React.Component<DragDropContextProps> {
  readonly store: DragDropContextStore;

  constructor(props: Readonly<DragDropContextProps>) {
    super(props);
    this.store = new DragDropContextStore(this);
  }

  render() {
    return (
      <DragDropReactContext.Provider value={this.store}>
        {this.props.children}
      </DragDropReactContext.Provider>);
  }

  componentWillUnmount() {
    this.store.dispose();
  }
}
